"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var React = _interopRequireWildcard(require("react"));
var _Translations = require("react-platform-components/dist/Translations");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var DeleteProductDialog = function DeleteProductDialog(props) {
  var isOpen = props.isOpen,
    type = props.type,
    setState = props.setState;
  var handleConfirm = function handleConfirm() {
    props.onClose(true);
  };
  var handleCancel = function handleCancel() {
    props.onClose(false);
  };
  return /*#__PURE__*/React.createElement(_core.Dialog, {
    open: isOpen,
    onClose: function onClose() {
      return setState(function (previousState) {
        return _objectSpread(_objectSpread({}, previousState), {}, {
          isAcceptCounterPropositionDialogOpen: false,
          isRefusedCounterPropositionDialogOpen: false
        });
      });
    },
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description"
  }, /*#__PURE__*/React.createElement(_core.DialogTitle, {
    id: "alert-dialog-title"
  }, type === "accept" ? /*#__PURE__*/React.createElement(_Translations.IntlMessages, {
    id: "chat.head.acceptOffer",
    defaultMessage: "chat.head.acceptOffer"
  }) : /*#__PURE__*/React.createElement(_Translations.IntlMessages, {
    id: "chat.head.refuseOffer",
    defaultMessage: "chat.head.refuseOffer"
  })), /*#__PURE__*/React.createElement(_core.DialogContent, null, type === "accept" && /*#__PURE__*/React.createElement(_core.DialogContentText, {
    id: "alert-dialog-description"
  }, /*#__PURE__*/React.createElement(_Translations.IntlMessages, {
    id: "chat.conversation.dialog.acceptOffer",
    defaultMessage: "chat.conversation.dialog.acceptOffer"
  })), type === "refused" && /*#__PURE__*/React.createElement(_core.DialogContentText, {
    id: "alert-dialog-description"
  }, /*#__PURE__*/React.createElement(_Translations.IntlMessages, {
    id: "chat.conversation.dialog.refusedOffer",
    defaultMessage: "chat.conversation.dialog.refusedOffer"
  }))), /*#__PURE__*/React.createElement(_core.DialogActions, null, /*#__PURE__*/React.createElement(_core.Button, {
    onClick: handleCancel,
    color: "primary",
    variant: "contained"
  }, /*#__PURE__*/React.createElement(_Translations.IntlMessages, {
    id: "offer.cancelButton",
    defaultMessage: "offer.cancelButton"
  })), /*#__PURE__*/React.createElement(_core.Button, {
    onClick: handleConfirm,
    color: "primary",
    variant: "contained"
  }, /*#__PURE__*/React.createElement(_Translations.IntlMessages, {
    id: "offer.confirmButton",
    defaultMessage: "offer.confirmButton"
  }))));
};
var _default = DeleteProductDialog;
exports.default = _default;